<app-form>
  <app-login-confirmation-form
    [loginConfirmationFormModel]="loginConfirmationFormModel"></app-login-confirmation-form>
</app-form>